import { X } from "lucide-react";
import React from "react";
import { useSelector } from "react-redux";
import { useGameSettings } from "../../slotGame/slotData";

export const PayTable = ({ onClose }) => {
    const { data } = useSelector((state) => state.gameSettings);
    const { scatterTriggerConfig } = useGameSettings()

    if (!data || !data.slotSymbols?.length) {
        return (<>
            <div className="py-3 text-2xl sm:text-3xl xl:text-5xl font-bold text-white">Pay Table</div>
            <div className="text-white text-2xl text-center pt-5">No pay table data available!</div>
        </>)
    }

    const bonusSymbol = data.slotSymbols.find((symbol) => symbol.is_bonus)
    const scatterSymbol = data.slotSymbols.find((symbol) => symbol.is_scatter);
    const wildSymbol = data.slotSymbols.find((symbol) => symbol.is_wild);
    const symbols = data.slotSymbols.filter((symbol) => !symbol.is_wild && !symbol.is_scatter && !symbol.is_bonus);

    return (
        <div className="flex flex-col w-full h-full mx-auto">
            <div className="w-full h-[10%] mb-2 text-white flex items-center justify-center relative xs:text-lg sm:text-lg md:text-2xl lg:text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-5xl font-bold border-b border-gray-500">
                <span className="absolute left-1/2 transform -translate-x-1/2">Pay Table</span>
                <button
                    className="absolute right-4 text-gray-50 bg-slate-700 p-1 hover:text-gray-300 text-xl rounded-full"
                    onClick={onClose}
                >
                    <X className="xs:w-2 xs:h-2 sm:w-3 sm:h-3 md:w-4 md:h-4 lg:w-7 lg:h-7 2xl:w-9 2xl:h-9 3xl:w-12 3xl:h-12" />
                </button>
            </div>
            {/* Scrollable content area */}
            <div className="flex-1 overflow-y-auto m-2 p-4 custom-scrollbar">

                {/* Bonus,Wild and Scatter Symbols - Shown in Single Column */}

                {bonusSymbol && (
                    <div className="flex flex-col items-center text-center xs:mb-6 lg:mb-20">
                        <img
                            src={bonusSymbol.image_url}
                            alt="bonus Symbol"
                            className="xs:w-2/5 md:w-2/6 lg:w-1/4 2xl:w-1/4 xs:h-2/5 md:h-2/6 lg:h-1/4 2xl:h-1/4 object-contain"
                        />
                        <div className="text-white py-2 text-lg sm:text-xl md:text-xl lg:text-xl 2xl:text-2xl font-bold">
                            Bonus
                        </div>
                        <div className="text-white py-2 text-base sm:text-lg md:text-lg lg:text-lg 2xl:text-2xl">
                            3 Bonus symbols on (reels 1, 3 and 5 ) trigger <br />
                            10 free spins at <br />
                            x2 winnings multiplier <br />
                        </div>
                        <div className="flex flex-wrap justify-center gap-4">
                            {scatterSymbol.payout?.length > 0 ? (
                                scatterSymbol.payout
                                    .filter((payout) => payout.count > 0)
                                    .map((payout) => (
                                        <div key={payout._id} className="text-white text-lg sm:text-xl md:text-lg lg:text-2xl px-4">
                                            <span>{payout.count} - x{payout.multiplier}</span>
                                        </div>
                                    ))
                            ) : (
                                <p className="text-white text-sm sm:text-base">No payout details available.</p>
                            )}
                        </div>
                    </div>
                )}

                {scatterSymbol && (
                    <div className="flex flex-col items-center text-center xs:mb-6 lg:mb-20">
                        <img
                            src={scatterSymbol.image_url}
                            alt="Scatter Symbol"
                            className="xs:w-2/5 md:w-2/6 lg:w-1/4 2xl:w-1/4 xs:h-2/5 md:h-2/6 lg:h-1/4 2xl:h-1/4 object-contain"
                        />
                        <div className="text-white py-2 text-lg sm:text-xl md:text-xl lg:text-xl 2xl:text-2xl font-bold">
                            Scatter
                        </div>
                        <div className="text-white py-2 text-base sm:text-lg md:text-lg lg:text-lg 2xl:text-2xl">
                        {scatterTriggerConfig?.countToTrigger &&
                            <>
                                {scatterTriggerConfig.countToTrigger} Scatter symbols on ( reels {scatterTriggerConfig.appearsOnReels?.join(", ")} ) trigger <br />
                                {scatterTriggerConfig.freeSpinsAwarded} free spins at payout multiplier x{scatterTriggerConfig.multiplier} <br />
                            </>
                        }
                            Scatter wins are multiplied by total bet.
                        </div>
                        <div className="flex flex-wrap justify-center gap-4">
                            {scatterSymbol.payout?.length > 0 ? (
                                scatterSymbol.payout
                                    .filter((payout) => payout.count > 0)
                                    .map((payout) => (
                                        <div key={payout._id} className="text-white text-lg sm:text-xl md:text-lg lg:text-2xl px-4">
                                            <span>{payout.count} - x{payout.multiplier}</span>
                                        </div>
                                    ))
                            ) : (
                                <p className="text-white text-sm sm:text-base">No payout details available.</p>
                            )}
                        </div>
                    </div>
                )}

                {wildSymbol && (
                    <div className="flex flex-col items-center text-center xs:mb-6 lg:mb-20">
                        <img
                            src={wildSymbol.image_url}
                            alt="Wild Symbol"
                            className="xs:w-2/5 md:w-2/6 lg:w-1/4 2xl:w-1/4 xs:h-2/5 md:h-2/6 lg:h-1/4 2xl:h-1/4 object-contain"
                        />
                        <div className="text-white py-2 text-lg sm:text-xl md:text-xl lg:text-xl 2xl:text-2xl font-bold">
                            Wild
                        </div>
                        <div className="text-white py-2 text-base sm:text-lg md:text-lg lg:text-lg 2xl:text-2xl">
                            Substitutes for all symbols in its own position, except the scatter.
                        </div>
                        <div className="text-white py-1 text-base sm:text-lg md:text-lg lg:text-2xl">
                            Double when substituting.
                        </div>
                        <div className="flex flex-wrap justify-center gap-4">
                            {wildSymbol.payout?.length > 0 ? (
                                wildSymbol.payout
                                    .filter((payout) => payout.count > 0)
                                    .map((payout) => (
                                        <div key={payout._id} className="text-white text-lg sm:text-xl md:text-lg lg:text-2xl px-4 py-2">
                                            <span>{payout.count} - x{payout.multiplier}</span>
                                        </div>
                                    ))
                            ) : (
                                <p className="text-white text-sm sm:text-base">No payout details available.</p>
                            )}
                        </div>
                    </div>
                )}

                {/* Regular Symbols - Displayed in Grid Format */}
                {symbols.length > 0 ? (
                    <div className="flex flex-col gap-8">
                        {/* Symbols with 4 payouts (Grid with 2 columns) */}
                        {symbols.filter(symbol => symbol.payout?.length === 4).length > 0 && (
                            <div className="grid grid-cols-2 gap-4">
                                {symbols.filter(symbol => symbol.payout?.length === 4).map((symbol) => (
                                    <div key={symbol._id} className="flex flex-col items-center text-center p-4 rounded-lg">
                                        <img
                                            src={symbol.image_url}
                                            alt={symbol.name}
                                            className="xs:w-2/3 lg:w-2/4 2xl:w-2/5 object-contain"
                                        />
                                        <div className="flex flex-wrap flex-col justify-center gap-3 pt-2">
                                            {symbol.payout.map((payout) => (
                                                <div key={payout._id} className="text-white text-lg sm:text-base lg:text-md xl:text-xl 2xl:text-2xl px-2">
                                                    <span>{payout.count} - x{payout.multiplier}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Symbols with 3 payouts (Grid with 3 columns) */}
                        {symbols.filter(symbol => symbol.payout?.length === 3).length > 0 && (
                            <div className="grid grid-cols-3 gap-4">
                                {symbols.filter(symbol => symbol.payout?.length === 3).map((symbol) => (
                                    <div key={symbol._id} className="flex flex-col items-center text-center xs:p-1 lg:p-4 rounded-lg">
                                        <img
                                            src={symbol.image_url}
                                            alt={symbol.name}
                                            className="xs:w-2/3 2xl:w-2/4 object-contain"
                                        />
                                        <div className="flex flex-wrap flex-col justify-center gap-3 pt-2">
                                            {symbol.payout.map((payout) => (
                                                <div key={payout._id} className="text-white text-lg sm:text-base lg:text-md xl:text-xl 2xl:text-2xl px-2">
                                                    <span>{payout.count} - x{payout.multiplier}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Remaining symbols (Default Grid) */}
                        {/* {symbols.filter(symbol => symbol.payout?.length < 5 || !symbol.payout).length > 0 && (
                            <div className="grid xs:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                                {symbols.filter(symbol => symbol.payout?.length < 5 || !symbol.payout).map((symbol) => (
                                    <div key={symbol._id} className="flex flex-col items-center text-center p-4 rounded-lg">
                                        <img
                                            src={symbol.image_url}
                                            alt={symbol.name}
                                            className="w-2/3 object-contain"
                                        />
                                        <div className="flex flex-wrap flex-col justify-center gap-3 pt-2">
                                            {symbol.payout.map((payout) => (
                                                <div key={payout._id} className="text-white text-lg sm:text-xl xl:text-2xl px-2">
                                                    <span>{payout.count} - x{payout.multiplier}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )} */}
                    </div>
                ) : (
                    <div className="text-white text-lg sm:text-xl text-center">No regular symbols available</div>
                )}
            </div>
        </div>
    );
};
